import * as React from 'react';
import { GdsAggregationServiceGroup } from '../../../../Checkout/types';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import { NASProductCategory } from '@websky/graphql';
import WrappedCommonCard from '../CommonCard/WrappedCommonCard';
import { getNasServiceCardParams } from '../utils';

interface Props {
	segmentId?: string;
	service: GdsAggregationServiceGroup;
}

const MeetAndGreet: React.FC<Props> = ({ service, segmentId }) => {
	const { t } = useTranslation('Checkout');
	const { t: aasT } = useTranslation('ServiceAggregation');
	const theme = useTheme('CheckoutAdditionalService').MeetAndGreet;

	const params = getNasServiceCardParams(NASProductCategory.meet_and_greet);

	return (
		<WrappedCommonCard
			segmentId={segmentId}
			category={NASProductCategory.meet_and_greet}
			header={t(params.title)}
			service={service}
			description={t(params.description)}
			coverClassName={theme.meet_and_greet}
			icons={params.icons}
		>
			{aasT('Entrance with boarding ticket')}
		</WrappedCommonCard>
	);
};

export default MeetAndGreet;
